export const CLASS_NAMES = {
  lineItems: 'flex flex-col gap-y-4 mb-8 w-full max-w-80 mt-2 md:mt-4',
};
